import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useIsOverflowing, Link} from "@careers-wales/react-components";
/**
 * A component for visualising data in scaled horizontal bars
 */
function ScaleBarGraph({ caption, data, xAxisLabel, xAxisMeasurements,xAxisAuto }) {
  const { t } = useTranslation();

  const ref = useRef(null);
  const containerRef = useRef(null);

  const isOverflowing = useIsOverflowing(containerRef);

  function getHighestValue(data) {
    return Math.ceil(Math.max.apply(Math, data.map(function(o) { return o.value; }))/ 10) * 10;
  }
  function generateXAxisMeasurements(input) {
    const last =  Math.ceil(input / 10) * 10;
    const result = [];
    for (let i = 0; i <= last; i += 10) {
      result.push(i);
    }
    return result;
  }

  let xAxisMax = 100
  if (xAxisAuto) {
    xAxisMax =  getHighestValue(data);
    xAxisMeasurements = generateXAxisMeasurements(xAxisMax);

    console.log(xAxisMax,xAxisMeasurements );
  }



  useLayoutEffect(() => {
    const cells = ref.current.querySelectorAll('tbody tr:first-of-type td:not(:last-of-type)');
    const bars = ref.current.querySelectorAll('tbody tr td:nth-of-type(1) div');

    let cellsWidth = 0;
    cells.forEach((cell) => {
      cellsWidth += cell.clientWidth;
    });

    data.forEach((item, index) => {
      bars[index].style.width = `${(item.value / 100) * cellsWidth  * (100/xAxisMax)}px`;
    });
  }, [data,xAxisMax]);

  const TablePrompt = (
    <div className="table__prompt" style={{ display: 'block' }}>
      {t('styleguide:tables_view_more')}
    </div>
  );

  const cellFillers = [];
  for (let i = 0; i < xAxisMeasurements.length - 2; i++) {
    cellFillers.push(<td />);
  }



  return (
    <div ref={ref} className="table table--comparison show-x-axis-caption">
      <div className="table__caption-placeholder" aria-hidden="true">
        {caption}
      </div>
      {isOverflowing && TablePrompt}
      <div ref={containerRef} className="table__container" style={isOverflowing ? {overflow:"auto"}: {overflow:"initial"}}>
        <table>
          <caption>{caption}</caption>
          {/* <thead>*/}
          {/*  <tr>*/}
          {/*      <th>{xAxisLabel}</th>*/}
          {/*      {xAxisMeasurements.map((measurement, index) => (*/}
          {/*          <th key={index}>{measurement}</th>*/}
          {/*      ))}*/}
          {/*    <th>{t('styelguide:percentage')}</th>*/}
          {/*  </tr>*/}
          {/*</thead>*/}
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <th scope="row">{item.url ? <Link href={item.url}>{item.name}</Link> : item.name}</th>
                <td>
                  <div aria-hidden="true" data-value={item.value} />
                </td>
                {cellFillers}
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th>{xAxisLabel}</th>
              {xAxisMeasurements.map((measurement, index) => (
                <th key={index}>{measurement}</th>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
      {isOverflowing && TablePrompt}
    </div>
  );
}

ScaleBarGraph.propTypes = {
  /**
   * The graph caption
   */
  caption: PropTypes.string,
  /**
   * The graph data
   */
  data: PropTypes.arrayOf(PropTypes.object),
  /**
   * The X axis label
   */
  xAxisLabel: PropTypes.string,
  /**
   * The X axis measurements
   */
  xAxisMeasurements: PropTypes.arrayOf(PropTypes.number)
};

export default ScaleBarGraph;
